import { get } from 'lodash';
import React from 'react';
import { NumberField, useRecordContext } from 'react-admin';

const CurrencyField = ({
  source,
  currencySource,
}: {
  source: string;
  currencySource: string;
}) => {
  const record = useRecordContext();
  const currency = get(record, currencySource);

  if (!currency) return '-';
  return (
    <NumberField
      source={source}
      emptyText="-"
      options={{
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        minimumFractionDigits: 0,
      }}
    />
  );
};

export default CurrencyField;
